import { ComponentProps } from "react";

import { cn } from "shared/utils/cn";

export const Input = ({ className, ...props }: ComponentProps<"input">) => {
  return (
    <input
      className={cn(
        "text-balticSea placeholder:text-balticSea/50 flex w-full rounded-lg bg-white px-3 py-2.5 outline-hidden",
        className
      )}
      {...props}
    />
  );
};
